import { alpha, createTheme } from "@mui/material/styles";

// "Court Lines · London" — a volleyball court in UI form: warm sand ground, a
// coral playing-court primary, a teal free-zone accent, white lines. Flat
// everywhere (no gradients), squared corners, chalk-uppercase labels.
export const makeTheme = (mode: "light" | "dark") =>
  createTheme({
    palette: {
      mode,
      primary: { main: mode === "light" ? "#e27a5f" : "#e8886e" },
      secondary: { main: mode === "light" ? "#2f9e97" : "#45b3ab" },
      ...(mode === "light"
        ? {
            background: { default: "#f2eee7", paper: "#ffffff" },
            text: { primary: "#1c211e", secondary: "#6f7a71" },
            divider: "#e5ddd0",
          }
        : {
            background: { default: "#16130e", paper: "#1e1a14" },
            text: { primary: "#ece7dd", secondary: "#9a9488" },
            divider: "#2c281f",
          }),
    },
    shape: { borderRadius: 8 },
    typography: {
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      h4: { fontWeight: 800, letterSpacing: "-0.01em" },
      h5: {
        fontWeight: 800,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
      },
      button: { textTransform: "uppercase", fontWeight: 700, letterSpacing: "0.06em" },
    },
    components: {
      MuiCard: {
        defaultProps: { elevation: 0 },
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: 10,
            border: `1.5px solid ${theme.palette.divider}`,
            boxShadow: "none",
          }),
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: { borderRadius: 8, paddingTop: 11, paddingBottom: 11 },
        },
      },
      MuiAlert: { styleOverrides: { root: { borderRadius: 8 } } },
      // Multi-choice rows (days, neighborhoods, levels) have to read as yes/no
      // at a glance. MUI's default "selected" is a faint grey tint that looks
      // like nothing is selected, and people clicked the days they wanted,
      // switching them off. So: on is a light tint of the teal accent, off is
      // greyed out behind diagonal stripes.
      MuiToggleButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.text.disabled,
            backgroundImage: `repeating-linear-gradient(135deg, transparent 0 5px, ${alpha(
              theme.palette.text.primary,
              0.07
            )} 5px 10px)`,
            "&:hover": {
              backgroundColor: alpha(theme.palette.text.primary, 0.04),
            },
            "&.Mui-selected, &.Mui-selected:hover": {
              backgroundImage: "none",
              backgroundColor: alpha(theme.palette.secondary.main, 0.14),
              color:
                theme.palette.mode === "light"
                  ? theme.palette.secondary.dark
                  : theme.palette.secondary.light,
            },
          }),
        },
      },
    },
  });
